// OperatorsTable.js

const OperatorsTable = ({ assessments, fieldOptions }) => {
  // Создаем маппинг операторов
  const assessmentsByOperator = {};
  // Инициализируем маппинг для каждого оператора
  if (fieldOptions?.operators && Array.isArray(fieldOptions.operators)) {
    fieldOptions.operators.forEach(operator => {
      const operatorFullName = `${operator.surname} ${operator.name}`;
      assessmentsByOperator[operatorFullName] = {};
      
      // Инициализируем вложенный маппинг для каждого уровня impact
      if (fieldOptions?.impact && Array.isArray(fieldOptions.impact)) {
        fieldOptions.impact.forEach(impactOption => {
          assessmentsByOperator[operatorFullName][impactOption.option_value] = [];
        });
      }
    });
  }

  // Распределяем оценки по операторам и уровням impact
  assessments.forEach(assessment => {
    const operator = assessment.agent_name;
    const impact = assessment.impact;
    
    if (operator && impact && 
        assessmentsByOperator[operator] && 
        assessmentsByOperator[operator][impact]) {
      assessmentsByOperator[operator][impact].push(assessment);
    }
  });
  // Формируем статистику из маппинга
  const stats = Object.entries(assessmentsByOperator).map(([operatorFullName, impactMap]) => {
    const operatorName = operatorFullName;
    
    // Создаем объект статистики для оператора
    const operatorStats = {
      operator: operatorName,
      impacts: {}
    };
    
    // Собираем статистику по каждому уровню impact
    let totalZeroScores = 0;
    let totalAssessments = 0;
    // let totalScoreSum = 0;
    Object.entries(impactMap).forEach(([impactValue, assessmentsList]) => {
      // Считаем количество критериев с score = 0
      const zeroScoreCount = assessmentsList.reduce((count, assessment) => {
        if (assessment.items && Array.isArray(assessment.items)) {
          return count + assessment.items.filter(item => item.score === 0).length;
        }
        return count;
      }, 0);
      
      // Считаем общее количество оценок для этого уровня impact
      const assessmentCount = assessmentsList.length;
      // Считаем средний процент как среднее значение total_score
      const totalScoreSum = assessmentsList.reduce((sum, assessment) => {
        return sum + assessment.total_score;
      }, 0);
      
      const averagePercentage = assessmentsList.length > 0 ? (totalScoreSum*100 / assessmentsList.length).toFixed(1) : '';
      
      // Находим option_text для уровня impact
      const impactOption = fieldOptions?.impact?.find(opt => opt.option_value === impactValue);
      const impactName = impactOption ? impactOption.option_text : impactValue;
      
      // Добавляем статистику для уровня impact
      operatorStats.impacts[impactName] = {
        Total: zeroScoreCount,
        "Q-ty": assessmentCount,
        "%": averagePercentage
      };
      
      // Обновляем общие суммы для оператора
      totalZeroScores += zeroScoreCount;
      totalAssessments += assessmentCount;
    });
    
    // Добавляем общие показатели для оператора
    operatorStats.Total = totalZeroScores;
    operatorStats["Q-ty"] = totalAssessments;
    
    // Считаем средний процент как среднее значение total_score по всем оценкам оператора
    const totalScoreSum = Object.values(impactMap).flat().reduce((sum, assessment) => {
      return sum + assessment.total_score;
    }, 0);
    
    operatorStats["%"]= Object.values(impactMap).flat().length > 0 ? 
      (totalScoreSum*100 / Object.values(impactMap).flat().length).toFixed(1) : '';
    return operatorStats;
  });

  // Рассчитываем среднее total_score по всем оценкам
  const totalQuality = assessments.length > 0
    ? (assessments.reduce((sum, assessment) => sum + assessment.total_score, 0)*100 / assessments.length).toFixed(1)
    : '0.0';
  
  // Сортируем по количеству оценок (по убыванию)
  const sortedStats = stats.sort((a, b) => b["%"] - a["%"]);

  // Получаем все уникальные названия impact из fieldOptions, исключая "No"
  const impactNames = fieldOptions?.impact?.map(impact => impact.option_text).filter(name => name !== "No") || [];
  
  // Функция для генерации ячеек заголовков
  const renderHeaderCells = () => {
    return impactNames.map(impactName => (
      <th key={impactName}>{impactName}</th>
    ));
  };

  // Функция для генерации ячеек данных
  const renderDataCells = (stat) => {
    return impactNames.map(impactName => (
      <td key={impactName}>
        {stat.impacts[impactName] ? stat.impacts[impactName]['Total'] : 0}
      </td>
    ));
  };

  // Функция для генерации ячеек футера
  const renderFooterCells = () => {
    return impactNames.map(impactName => (
      <td key={impactName}>
        {sortedStats.reduce((sum, stat) => sum + (stat.impacts[impactName] ? stat.impacts[impactName]['Total'] : 0), 0)}
      </td>
    ));
  };
  
  return (
    <div className="table-wrapper flex-6">
      <h3>Статистика по операторам</h3>
      <table className="stats-table">
        <thead>
        <tr>
          <th>Оператор</th>
          {renderHeaderCells()}
          <th>Количество ошибок</th>
          <th>Количество проверок</th>
          <th>% ошибок</th>
          <th>Средний % качества</th>
        </tr>
        </thead>
        <tbody>
        {sortedStats.map((stat) => (
            <tr key={stat.operator}>
              <td>{stat.operator}</td>
              {renderDataCells(stat)}
              <td>{stat.Total}</td>
              <td>{stat["Q-ty"]}</td>
              {stat["Q-ty"] > 0
                  ? <td>{((stat.Total / stat["Q-ty"]) * 100).toFixed(1)}%</td>
                  :
                  <td></td>
              }

              {stat["%"] !== '' ?
                  <td
                      style={{
                        backgroundColor: (() => {
                          const value = parseFloat(stat["%"]); // Уже умножено на 100
                          if (value > 93) return '#C6EFCE'; // Зеленый
                          if (value >= 80) return '#FFEB9C'; // Желтый
                          return '#FFC7CE'; // Красный
                        })(),
                        textAlign: 'center',
                        fontWeight: 'bold',
                        padding: '8px',
                        border: '1px solid #ddd'
                      }}
                  >
                    {stat["%"]} %
                  </td>
                  : <td></td>
              }

            </tr>
        ))}
        {sortedStats.length === 0 && (
            <tr>
              <td colSpan={impactNames.length + 5} style={{textAlign: 'center'}}>Нет данных для отображения</td>
            </tr>
        )}

        </tbody>
        <tfoot>
          <tr>
            <td>Grand Total</td>
            {renderFooterCells()}
            <td>{sortedStats.reduce((sum, stat) => sum + stat.Total, 0)}</td>
            <td>{sortedStats.reduce((sum, stat) => sum + stat["Q-ty"], 0)}</td>
            <td>{sortedStats.length > 0 ? ((sortedStats.reduce((sum, stat) => sum + stat.Total, 0) / sortedStats.reduce((sum, stat) => sum + stat["Q-ty"], 0)) * 100).toFixed(1) : '0.0'}%</td>
            <td>{totalQuality} %</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default OperatorsTable;
